import React from "react";
import { Typography, Box } from "@mui/material";

interface SectionTitleProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: "left" | "center" | "right";
}

export default function SectionTitle({
  eyebrow,
  title,
  subtitle,
  align = "center",
}: SectionTitleProps) {
  return (
    <Box textAlign={align} mb={4}>
      {eyebrow ? (
        <Typography
          variant="overline"
          sx={{
            letterSpacing: 2,
            fontWeight: 600,
            color: (theme) => theme.palette.primary.main,
            textTransform: "uppercase",
          }}
        >
          {eyebrow}
        </Typography>
      ) : null}
      <Typography variant="h2" component="h2" sx={{ fontWeight: 700 }}>
        {title}
      </Typography>
      {subtitle ? (
        <Typography
          variant="body1"
          sx={{
            mt: 1,
            color: (theme) => theme.palette.text.secondary,
            maxWidth: 680,
            mx: align === "center" ? "auto" : undefined,
          }}
        >
          {subtitle}
        </Typography>
      ) : null}
    </Box>
  );
}
